import { useRef } from 'react';
import { useConditionalEffect } from './conditional-effect.js';

export function useOnceEffect(
  callback: VoidFunction,
  shouldTrigger = true
): void {
  const hasExecuted = useRef(false);

  useConditionalEffect(() => {
    if (hasExecuted.current) {
      return;
    }

    callback();

    hasExecuted.current = true;
  }, shouldTrigger);
}
